var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zmdet_t"},[_c('div',{staticClass:"lawzm_detail"},[_c('div',{staticClass:"bt1"},[_vm._v(_vm._s(_vm.det.title))]),_c('div',{staticClass:"lawdet",domProps:{"innerHTML":_vm._s(_vm.det.cont)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }